import React, { useCallback, useState } from "react";
import Api from "../../../utils/api.utils";
import { apiURL } from "../../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { getApiData } from "../../selector/auth.selector";
import { get } from "lodash";
import {
  getSelectedDate,
  getSelectedVisit,
} from "../../selector/visits.selector";
import { setHypoglycemia } from "../../reducer/hypoglycemia.reducer";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducer/pageLoader.reducer";

const useHypoglycemiaList = () => {
  const loginData = useSelector(getApiData);
  const selectedVisit = useSelector(getSelectedVisit);
  const dispatch = useDispatch();

  const selectedDate = useSelector(getSelectedDate);
  const fetchRecordsList = useCallback(async (pageId) => {
    try {
      dispatch(showPageLoader());
      const subjectId = get(loginData, "SubjectId", "");
      const visitId = parseInt(get(selectedVisit, "VisitId", ""));
      const { data } = await Api.post({
        url: apiURL.getSavedData(),
        data: {
          SubjectId: subjectId,
          VisitId: visitId,
          PageId: pageId,
        },
      });
      dispatch(setHypoglycemia(data.data));
      dispatch(hidePageLoader());
    } catch (error) {
      console.log("err==>", error);
      dispatch(hidePageLoader());
    }
  });
  return { fetchRecordsList };
};

export default useHypoglycemiaList;
